import { memo, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { Box, Flex } from '@mantine/core';
import { useIsFirstRender } from '@mantine/hooks';

import { useMutation } from '@tanstack/react-query';

import { selectPersonId } from '@/store/user-process/user-selectors.ts';

import { BookContextProvider } from '@/contexts/BookContext/BookContextProvider';

import { FIREBASE_APP_ID } from '@/constant/api.ts';

import { Calendar } from '@/entities/Calendar';
import { InitSettings } from '@/entities/Settings/components/InitSettings.tsx';
import { WorkTimeSelector } from '@/entities/WorkTimeSelector/WorkTimeSelector';

import { LocationSelectorSheet } from '@/features/LocationSelectorSheet';

import { BookUp } from '@/widgets/BookUp';
import { Location } from '@/widgets/Location';
import { PersonalPlaces } from '@/widgets/PersonalPlaces';
import { Radar } from '@/widgets/Radar';
import { Support } from '@/widgets/Support';
import { WidgetsBoard } from '@/widgets/WidgetsBoard';
import { ActiveBooking } from '@/widgets/activeBooking';

import { notificationsApi } from '@/shared/api/notifications.ts';
import useInstallPWA from '@/shared/hooks/useInstallPWA.tsx';
import { DesktopLayout } from '@/shared/layouts/DesktopLayout';
import useAppStore from '@/shared/store/app.store';
import { useSettingsStore } from '@/shared/store/settings.store.ts';
import useUserStore from '@/shared/store/user.store.ts';
import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

import { useAppSelector } from '@/hooks';

const Main = () => {
	const isMobile = useAppStore((state) => state.isMobile);
	const user = useUserStore((state) => state.user);
	const workTime = useSettingsStore((state) => state.workTime);
	const location = useSettingsStore((state) => state.location);
	// const { isMobile, workTime, location } = useAppStore();
	const installPwa = useInstallPWA();
	const personId = useAppSelector(selectPersonId);

	const { mutate: registrationToken } = useMutation({
		mutationFn: notificationsApi.registrationToken,
		onSuccess: () => console.log('Server registration is success'),
	});

	useEffect(() => {
		const pushToken = localStorage.getItem('notify');

		if (pushToken && personId) {
			registrationToken({
				person_id: personId,
				firebase_client_token: pushToken,
				app_id: FIREBASE_APP_ID ?? '',
			});
		}
	}, [personId]);

	if (!workTime || !location) return <InitSettings />;

	// if (workTime?.some((time) => !time)) return <WorkTimeSelector />;
	// if (!Object?.keys(location ?? {}).length)
	// 	return <LocationSelectorSheet title="Локация" close={() => false} />;

	if (isMobile === null) return;

	if (isMobile)
		return (
			<>
				<Flex direction="column" gap={6}>
					<BookContextProvider>
						<Location />
						<PersonalPlaces />
						<ActiveBooking />
						<Radar />
						<BookUp />
					</BookContextProvider>
					<WidgetsBoard />
					<Box mx={'auto'} w={'max-content'}>
						{installPwa}
					</Box>
					{/* <OfficeLife /> */}
				</Flex>
			</>
		);

	return (
		<BookContextProvider>
			<DesktopLayout
				leftSlot={
					<>
						<Location />
						<Calendar />
						{/* <OfficeLife /> */}
						<PersonalPlaces />
						<ActiveBooking />
						<Radar />
						<LayoutRow
							type="once"
							title={{
								title: { children: 'Поддержка', size: 'h4', fw: 800, ta: 'center' },
							}}
						>
							<Support />
						</LayoutRow>
					</>
				}
				rightSlot={<Outlet />}
			/>
		</BookContextProvider>
	);
};

export default memo(Main);
